import { MDBBtn, MDBCard, MDBCardBody,MDBInput} from 'mdbreact';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import vi_logo from '../../Assets/visaero_logo.png';
import vd_logo from '../../Assets/visadone_logo.png';
import styles from './EnterEmail.module.css';

export class EnterEmail extends React.Component {
    constructor(props) {
        super(props)
    
        this.state = {
             logo:'',
             host_name:'VisaDone',
             brand_color : ""
        }
    }
    
    componentDidMount(){
        this.setState({brand_color : localStorage.getItem("brand_color")})
        const host = localStorage.getItem('host');
        if(host == "visaero"){
            this.setState({logo:vi_logo})
            this.setState({host_name: 'Visaero'})
        }else if(host == "visadone"){
          this.setState({logo:vd_logo})
          this.setState({host_name: 'VisaDone'})
        }
    }

    toggleShow = () => {
        this.setState({ hidden: !this.state.hidden });
    }

    handleEmail = (e) => {
        // console.log(e.target.value)
    }

    render(){
        return(
            <MDBCard >
                <MDBCardBody >
                    <div className="text-center">
                        <img src={this.state.logo} className={localStorage.getItem("host") == "visadone" ? "visadone_logo" : "visaero_logo"  +" img-fluid"}></img>
                    </div>
                    <div className="text-left mt-4">
                        <h3><b>Hello !</b></h3>
                    </div>
                    <div className="text-left">
                        <h5>Welcome to {this.statehost_name}</h5>
                    </div>
                    <div  className="text-left" style={{marginTop:'40%'}}>
                        <MDBInput label="Email ID" onChange={this.handleEmail} />
                    </div>
                    <div className="mb-2 mt-2">
                        <RouterLink to="/news" ><MDBBtn id={styles.logoutBtn} style={{backgroundColor : this.state.brand_color}}  color="none">Continue</MDBBtn></RouterLink>
                    </div>
                </MDBCardBody>
            </MDBCard>
        );
    }
};

export default EnterEmail;